module.exports = __webpack_public_path__ + "static/media/Python_example.ffc7a475.zip";